import { DesignCommonModuleItem } from './design-common-module-item';
import { DesignInput } from './design-input';
import { DesignItemType } from './design-item-type';
import { DesignModuleLocalVariable } from './design-module-local-variable';
import { DesignModuleVersion } from './design-module-version';
import { DesignOutput } from './design-output';
import { NodeType } from './node-type';
import { NodeTypeName } from './node-type-name';

/** @see Design.components.modules. */
export type DesignModule = {
  _class: NodeType.module;
  id: string;
  isHidden?: boolean;
  localVariables?: DesignModuleLocalVariable[];
  name: string;
  props: DesignCommonModuleItem & {
    author?: string;
    colorClass?: string;
    commonModuleName?: string;
    config: {
      description?: string;
      disabledInFlow?: boolean;
      inputs?: DesignInput[];
      outputs?: DesignOutput[];
      sensitiveOverrides?: {
        enabled: boolean;
        lastLocalChange: number;

      };
    };
    createdTime?: number;
    iconClass?: string;
    isCommonModule?: boolean;
    isRootModule?: boolean;
    lastLocalChange: number;
    lastSavedChange: number;
    nodeTypeName: NodeTypeName.module;
    ref?: string;
    timeAddedToFlow: number;
    usedIn?: string[];
  };
  repoName?: string;
  repoVersion?: string;
  type: DesignItemType.module;
  version: 1 | '1';
  versions: {
    1: DesignModuleVersion;
  };
};

export namespace DesignModule {
  const stringKeys: (keyof(DesignModule))[] = [
    '_class',
    'id',
    'name',
    'type'
  ];

  export function is(value: unknown): value is DesignModule {
    return !validate(value).length;
  }

  export function validate(
    value: unknown,
    baseKey = ''
  ): [string, { value: unknown; }][] {
    if (value == null || typeof value !== 'object') {
      return [[baseKey, { value }]];
    }

    const validation = [
      ...stringKeys.filter((key) => {
        return typeof (value as DesignModule)[key] !== 'string';
      })
    ].map((key): [string, { value: unknown; }] => {
      return [(baseKey) ? `${baseKey}.${key}` : key, { value: (value as DesignModule)[key] }];
    });

    return validation;
  }
}
